
export const FirebasePassword = "MDCVISH1919";
export const RazorpayIDLive = "rzp_live_FNIszXsXwTiR4y"
export const RazorpayIDTest = "rzp_test_AYzIKcTuwBRf9g"